/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as MenuIndexRouteImport } from './routes/_menu/index'
import { Route as OidcErrorRouteImport } from './routes/oidc/error'
import { Route as OidcAuthRouteImport } from './routes/oidc/auth'
import { Route as InvitesInviteIdRouteImport } from './routes/invites/$inviteId'
import { Route as LinksResetIndexRouteImport } from './routes/links/reset/index'
import { Route as LinksResetUuidRouteImport } from './routes/links/reset/$uuid'
import { Route as LinksOidcErrorRouteImport } from './routes/links/oidc/error'
import { Route as LinksOidcAuthRouteImport } from './routes/links/oidc/auth'
import { Route as LinksInviteInviteIdRouteImport } from './routes/links/invite/$inviteId'
import { Route as MenuProfileProfileRouteImport } from './routes/_menu/profile/_profile'
import { Route as MenuMDashboardRouteImport } from './routes/_menu/m/dashboard'
import { Route as MenuProfileProfileIndexRouteImport } from './routes/_menu/profile/_profile/index'
import { Route as MenuAOidcIndexRouteImport } from './routes/_menu/a/oidc/index'
import { Route as MenuAClubsIndexRouteImport } from './routes/_menu/a/clubs/index'
import { Route as MenuAAdminsIndexRouteImport } from './routes/_menu/a/admins/index'
import { Route as MenuProfileProfileSecurityRouteImport } from './routes/_menu/profile/_profile/security'
import { Route as MenuProfileProfileGeneralRouteImport } from './routes/_menu/profile/_profile/general'
import { Route as MenuCaClubIdClubRouteImport } from './routes/_menu/ca/$clubId/_club'
import { Route as MenuCaClubIdClubIndexRouteImport } from './routes/_menu/ca/$clubId/_club/index'
import { Route as MenuCaClubIdClubMembersRouteImport } from './routes/_menu/ca/$clubId/_club/members'
import { Route as MenuCaClubIdClubInvitedRouteImport } from './routes/_menu/ca/$clubId/_club/invited'
import { Route as MenuCaClubIdClubDashboardRouteImport } from './routes/_menu/ca/$clubId/_club/dashboard'
import { Route as MenuAClubsClubIdClubRouteImport } from './routes/_menu/a/clubs/$clubId/_club'
import { Route as MenuAClubsClubIdClubMembersRouteImport } from './routes/_menu/a/clubs/$clubId/_club/members'
import { Route as MenuAClubsClubIdClubDomainsRouteImport } from './routes/_menu/a/clubs/$clubId/_club/domains'
import { Route as MenuAClubsClubIdClubDashboardRouteImport } from './routes/_menu/a/clubs/$clubId/_club/dashboard'
import { Route as MenuAClubsClubIdClubAdminsRouteImport } from './routes/_menu/a/clubs/$clubId/_club/admins'

const MenuLazyRouteImport = createFileRoute('/_menu')()

const MenuLazyRoute = MenuLazyRouteImport.update({
  id: '/_menu',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_menu.lazy').then((d) => d.Route))
const MenuIndexRoute = MenuIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MenuLazyRoute,
} as any)
const OidcErrorRoute = OidcErrorRouteImport.update({
  id: '/oidc/error',
  path: '/oidc/error',
  getParentRoute: () => rootRouteImport,
} as any)
const OidcAuthRoute = OidcAuthRouteImport.update({
  id: '/oidc/auth',
  path: '/oidc/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitesInviteIdRoute = InvitesInviteIdRouteImport.update({
  id: '/invites/$inviteId',
  path: '/invites/$inviteId',
  getParentRoute: () => rootRouteImport,
} as any)
const LinksResetIndexRoute = LinksResetIndexRouteImport.update({
  id: '/links/reset/',
  path: '/links/reset/',
  getParentRoute: () => rootRouteImport,
} as any)
const LinksResetUuidRoute = LinksResetUuidRouteImport.update({
  id: '/links/reset/$uuid',
  path: '/links/reset/$uuid',
  getParentRoute: () => rootRouteImport,
} as any)
const LinksOidcErrorRoute = LinksOidcErrorRouteImport.update({
  id: '/links/oidc/error',
  path: '/links/oidc/error',
  getParentRoute: () => rootRouteImport,
} as any)
const LinksOidcAuthRoute = LinksOidcAuthRouteImport.update({
  id: '/links/oidc/auth',
  path: '/links/oidc/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LinksInviteInviteIdRoute = LinksInviteInviteIdRouteImport.update({
  id: '/links/invite/$inviteId',
  path: '/links/invite/$inviteId',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuProfileProfileRoute = MenuProfileProfileRouteImport.update({
  id: '/profile/_profile',
  path: '/profile',
  getParentRoute: () => MenuLazyRoute,
} as any)
const MenuMDashboardRoute = MenuMDashboardRouteImport.update({
  id: '/m/dashboard',
  path: '/m/dashboard',
  getParentRoute: () => MenuLazyRoute,
} as any)
const MenuProfileProfileIndexRoute = MenuProfileProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MenuProfileProfileRoute,
} as any)
const MenuAOidcIndexRoute = MenuAOidcIndexRouteImport.update({
  id: '/a/oidc/',
  path: '/a/oidc/',
  getParentRoute: () => MenuLazyRoute,
} as any)
const MenuAClubsIndexRoute = MenuAClubsIndexRouteImport.update({
  id: '/a/clubs/',
  path: '/a/clubs/',
  getParentRoute: () => MenuLazyRoute,
} as any)
const MenuAAdminsIndexRoute = MenuAAdminsIndexRouteImport.update({
  id: '/a/admins/',
  path: '/a/admins/',
  getParentRoute: () => MenuLazyRoute,
} as any)
const MenuProfileProfileSecurityRoute =
  MenuProfileProfileSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => MenuProfileProfileRoute,
  } as any)
const MenuProfileProfileGeneralRoute =
  MenuProfileProfileGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => MenuProfileProfileRoute,
  } as any)
const MenuCaClubIdClubRoute = MenuCaClubIdClubRouteImport.update({
  id: '/ca/$clubId/_club',
  path: '/ca/$clubId',
  getParentRoute: () => MenuLazyRoute,
} as any)
const MenuCaClubIdClubIndexRoute = MenuCaClubIdClubIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MenuCaClubIdClubRoute,
} as any)
const MenuCaClubIdClubMembersRoute = MenuCaClubIdClubMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => MenuCaClubIdClubRoute,
} as any)
const MenuCaClubIdClubInvitedRoute = MenuCaClubIdClubInvitedRouteImport.update({
  id: '/invited',
  path: '/invited',
  getParentRoute: () => MenuCaClubIdClubRoute,
} as any)
const MenuCaClubIdClubDashboardRoute =
  MenuCaClubIdClubDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => MenuCaClubIdClubRoute,
  } as any)
const MenuAClubsClubIdClubRoute = MenuAClubsClubIdClubRouteImport.update({
  id: '/a/clubs/$clubId/_club',
  path: '/a/clubs/$clubId',
  getParentRoute: () => MenuLazyRoute,
} as any)
const MenuAClubsClubIdClubMembersRoute =
  MenuAClubsClubIdClubMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => MenuAClubsClubIdClubRoute,
  } as any)
const MenuAClubsClubIdClubDomainsRoute =
  MenuAClubsClubIdClubDomainsRouteImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => MenuAClubsClubIdClubRoute,
  } as any)
const MenuAClubsClubIdClubDashboardRoute =
  MenuAClubsClubIdClubDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => MenuAClubsClubIdClubRoute,
  } as any)
const MenuAClubsClubIdClubAdminsRoute =
  MenuAClubsClubIdClubAdminsRouteImport.update({
    id: '/admins',
    path: '/admins',
    getParentRoute: () => MenuAClubsClubIdClubRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof MenuIndexRoute
  '/invites/$inviteId': typeof InvitesInviteIdRoute
  '/oidc/auth': typeof OidcAuthRoute
  '/oidc/error': typeof OidcErrorRoute
  '/m/dashboard': typeof MenuMDashboardRoute
  '/profile': typeof MenuProfileProfileRouteWithChildren
  '/links/invite/$inviteId': typeof LinksInviteInviteIdRoute
  '/links/oidc/auth': typeof LinksOidcAuthRoute
  '/links/oidc/error': typeof LinksOidcErrorRoute
  '/links/reset/$uuid': typeof LinksResetUuidRoute
  '/links/reset/': typeof LinksResetIndexRoute
  '/ca/$clubId': typeof MenuCaClubIdClubRouteWithChildren
  '/profile/general': typeof MenuProfileProfileGeneralRoute
  '/profile/security': typeof MenuProfileProfileSecurityRoute
  '/a/admins/': typeof MenuAAdminsIndexRoute
  '/a/clubs/': typeof MenuAClubsIndexRoute
  '/a/oidc/': typeof MenuAOidcIndexRoute
  '/profile/': typeof MenuProfileProfileIndexRoute
  '/a/clubs/$clubId': typeof MenuAClubsClubIdClubRouteWithChildren
  '/ca/$clubId/dashboard': typeof MenuCaClubIdClubDashboardRoute
  '/ca/$clubId/invited': typeof MenuCaClubIdClubInvitedRoute
  '/ca/$clubId/members': typeof MenuCaClubIdClubMembersRoute
  '/ca/$clubId/': typeof MenuCaClubIdClubIndexRoute
  '/a/clubs/$clubId/admins': typeof MenuAClubsClubIdClubAdminsRoute
  '/a/clubs/$clubId/dashboard': typeof MenuAClubsClubIdClubDashboardRoute
  '/a/clubs/$clubId/domains': typeof MenuAClubsClubIdClubDomainsRoute
  '/a/clubs/$clubId/members': typeof MenuAClubsClubIdClubMembersRoute
}
export interface FileRoutesByTo {
  '/invites/$inviteId': typeof InvitesInviteIdRoute
  '/oidc/auth': typeof OidcAuthRoute
  '/oidc/error': typeof OidcErrorRoute
  '/': typeof MenuIndexRoute
  '/m/dashboard': typeof MenuMDashboardRoute
  '/links/invite/$inviteId': typeof LinksInviteInviteIdRoute
  '/links/oidc/auth': typeof LinksOidcAuthRoute
  '/links/oidc/error': typeof LinksOidcErrorRoute
  '/links/reset/$uuid': typeof LinksResetUuidRoute
  '/links/reset': typeof LinksResetIndexRoute
  '/profile/general': typeof MenuProfileProfileGeneralRoute
  '/profile/security': typeof MenuProfileProfileSecurityRoute
  '/a/admins': typeof MenuAAdminsIndexRoute
  '/a/clubs': typeof MenuAClubsIndexRoute
  '/a/oidc': typeof MenuAOidcIndexRoute
  '/profile': typeof MenuProfileProfileIndexRoute
  '/a/clubs/$clubId': typeof MenuAClubsClubIdClubRouteWithChildren
  '/ca/$clubId/dashboard': typeof MenuCaClubIdClubDashboardRoute
  '/ca/$clubId/invited': typeof MenuCaClubIdClubInvitedRoute
  '/ca/$clubId/members': typeof MenuCaClubIdClubMembersRoute
  '/ca/$clubId': typeof MenuCaClubIdClubIndexRoute
  '/a/clubs/$clubId/admins': typeof MenuAClubsClubIdClubAdminsRoute
  '/a/clubs/$clubId/dashboard': typeof MenuAClubsClubIdClubDashboardRoute
  '/a/clubs/$clubId/domains': typeof MenuAClubsClubIdClubDomainsRoute
  '/a/clubs/$clubId/members': typeof MenuAClubsClubIdClubMembersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_menu': typeof MenuLazyRouteWithChildren
  '/invites/$inviteId': typeof InvitesInviteIdRoute
  '/oidc/auth': typeof OidcAuthRoute
  '/oidc/error': typeof OidcErrorRoute
  '/_menu/': typeof MenuIndexRoute
  '/_menu/m/dashboard': typeof MenuMDashboardRoute
  '/_menu/profile/_profile': typeof MenuProfileProfileRouteWithChildren
  '/links/invite/$inviteId': typeof LinksInviteInviteIdRoute
  '/links/oidc/auth': typeof LinksOidcAuthRoute
  '/links/oidc/error': typeof LinksOidcErrorRoute
  '/links/reset/$uuid': typeof LinksResetUuidRoute
  '/links/reset/': typeof LinksResetIndexRoute
  '/_menu/ca/$clubId/_club': typeof MenuCaClubIdClubRouteWithChildren
  '/_menu/profile/_profile/general': typeof MenuProfileProfileGeneralRoute
  '/_menu/profile/_profile/security': typeof MenuProfileProfileSecurityRoute
  '/_menu/a/admins/': typeof MenuAAdminsIndexRoute
  '/_menu/a/clubs/': typeof MenuAClubsIndexRoute
  '/_menu/a/oidc/': typeof MenuAOidcIndexRoute
  '/_menu/profile/_profile/': typeof MenuProfileProfileIndexRoute
  '/_menu/a/clubs/$clubId/_club': typeof MenuAClubsClubIdClubRouteWithChildren
  '/_menu/ca/$clubId/_club/dashboard': typeof MenuCaClubIdClubDashboardRoute
  '/_menu/ca/$clubId/_club/invited': typeof MenuCaClubIdClubInvitedRoute
  '/_menu/ca/$clubId/_club/members': typeof MenuCaClubIdClubMembersRoute
  '/_menu/ca/$clubId/_club/': typeof MenuCaClubIdClubIndexRoute
  '/_menu/a/clubs/$clubId/_club/admins': typeof MenuAClubsClubIdClubAdminsRoute
  '/_menu/a/clubs/$clubId/_club/dashboard': typeof MenuAClubsClubIdClubDashboardRoute
  '/_menu/a/clubs/$clubId/_club/domains': typeof MenuAClubsClubIdClubDomainsRoute
  '/_menu/a/clubs/$clubId/_club/members': typeof MenuAClubsClubIdClubMembersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/invites/$inviteId'
    | '/oidc/auth'
    | '/oidc/error'
    | '/m/dashboard'
    | '/profile'
    | '/links/invite/$inviteId'
    | '/links/oidc/auth'
    | '/links/oidc/error'
    | '/links/reset/$uuid'
    | '/links/reset/'
    | '/ca/$clubId'
    | '/profile/general'
    | '/profile/security'
    | '/a/admins/'
    | '/a/clubs/'
    | '/a/oidc/'
    | '/profile/'
    | '/a/clubs/$clubId'
    | '/ca/$clubId/dashboard'
    | '/ca/$clubId/invited'
    | '/ca/$clubId/members'
    | '/ca/$clubId/'
    | '/a/clubs/$clubId/admins'
    | '/a/clubs/$clubId/dashboard'
    | '/a/clubs/$clubId/domains'
    | '/a/clubs/$clubId/members'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/invites/$inviteId'
    | '/oidc/auth'
    | '/oidc/error'
    | '/'
    | '/m/dashboard'
    | '/links/invite/$inviteId'
    | '/links/oidc/auth'
    | '/links/oidc/error'
    | '/links/reset/$uuid'
    | '/links/reset'
    | '/profile/general'
    | '/profile/security'
    | '/a/admins'
    | '/a/clubs'
    | '/a/oidc'
    | '/profile'
    | '/a/clubs/$clubId'
    | '/ca/$clubId/dashboard'
    | '/ca/$clubId/invited'
    | '/ca/$clubId/members'
    | '/ca/$clubId'
    | '/a/clubs/$clubId/admins'
    | '/a/clubs/$clubId/dashboard'
    | '/a/clubs/$clubId/domains'
    | '/a/clubs/$clubId/members'
  id:
    | '__root__'
    | '/_menu'
    | '/invites/$inviteId'
    | '/oidc/auth'
    | '/oidc/error'
    | '/_menu/'
    | '/_menu/m/dashboard'
    | '/_menu/profile/_profile'
    | '/links/invite/$inviteId'
    | '/links/oidc/auth'
    | '/links/oidc/error'
    | '/links/reset/$uuid'
    | '/links/reset/'
    | '/_menu/ca/$clubId/_club'
    | '/_menu/profile/_profile/general'
    | '/_menu/profile/_profile/security'
    | '/_menu/a/admins/'
    | '/_menu/a/clubs/'
    | '/_menu/a/oidc/'
    | '/_menu/profile/_profile/'
    | '/_menu/a/clubs/$clubId/_club'
    | '/_menu/ca/$clubId/_club/dashboard'
    | '/_menu/ca/$clubId/_club/invited'
    | '/_menu/ca/$clubId/_club/members'
    | '/_menu/ca/$clubId/_club/'
    | '/_menu/a/clubs/$clubId/_club/admins'
    | '/_menu/a/clubs/$clubId/_club/dashboard'
    | '/_menu/a/clubs/$clubId/_club/domains'
    | '/_menu/a/clubs/$clubId/_club/members'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  MenuLazyRoute: typeof MenuLazyRouteWithChildren
  InvitesInviteIdRoute: typeof InvitesInviteIdRoute
  OidcAuthRoute: typeof OidcAuthRoute
  OidcErrorRoute: typeof OidcErrorRoute
  LinksInviteInviteIdRoute: typeof LinksInviteInviteIdRoute
  LinksOidcAuthRoute: typeof LinksOidcAuthRoute
  LinksOidcErrorRoute: typeof LinksOidcErrorRoute
  LinksResetUuidRoute: typeof LinksResetUuidRoute
  LinksResetIndexRoute: typeof LinksResetIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_menu': {
      id: '/_menu'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MenuLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_menu/': {
      id: '/_menu/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MenuIndexRouteImport
      parentRoute: typeof MenuLazyRoute
    }
    '/oidc/error': {
      id: '/oidc/error'
      path: '/oidc/error'
      fullPath: '/oidc/error'
      preLoaderRoute: typeof OidcErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oidc/auth': {
      id: '/oidc/auth'
      path: '/oidc/auth'
      fullPath: '/oidc/auth'
      preLoaderRoute: typeof OidcAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invites/$inviteId': {
      id: '/invites/$inviteId'
      path: '/invites/$inviteId'
      fullPath: '/invites/$inviteId'
      preLoaderRoute: typeof InvitesInviteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/links/reset/': {
      id: '/links/reset/'
      path: '/links/reset'
      fullPath: '/links/reset/'
      preLoaderRoute: typeof LinksResetIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/links/reset/$uuid': {
      id: '/links/reset/$uuid'
      path: '/links/reset/$uuid'
      fullPath: '/links/reset/$uuid'
      preLoaderRoute: typeof LinksResetUuidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/links/oidc/error': {
      id: '/links/oidc/error'
      path: '/links/oidc/error'
      fullPath: '/links/oidc/error'
      preLoaderRoute: typeof LinksOidcErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/links/oidc/auth': {
      id: '/links/oidc/auth'
      path: '/links/oidc/auth'
      fullPath: '/links/oidc/auth'
      preLoaderRoute: typeof LinksOidcAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/links/invite/$inviteId': {
      id: '/links/invite/$inviteId'
      path: '/links/invite/$inviteId'
      fullPath: '/links/invite/$inviteId'
      preLoaderRoute: typeof LinksInviteInviteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_menu/profile/_profile': {
      id: '/_menu/profile/_profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof MenuProfileProfileRouteImport
      parentRoute: typeof MenuLazyRoute
    }
    '/_menu/m/dashboard': {
      id: '/_menu/m/dashboard'
      path: '/m/dashboard'
      fullPath: '/m/dashboard'
      preLoaderRoute: typeof MenuMDashboardRouteImport
      parentRoute: typeof MenuLazyRoute
    }
    '/_menu/profile/_profile/': {
      id: '/_menu/profile/_profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof MenuProfileProfileIndexRouteImport
      parentRoute: typeof MenuProfileProfileRoute
    }
    '/_menu/a/oidc/': {
      id: '/_menu/a/oidc/'
      path: '/a/oidc'
      fullPath: '/a/oidc/'
      preLoaderRoute: typeof MenuAOidcIndexRouteImport
      parentRoute: typeof MenuLazyRoute
    }
    '/_menu/a/clubs/': {
      id: '/_menu/a/clubs/'
      path: '/a/clubs'
      fullPath: '/a/clubs/'
      preLoaderRoute: typeof MenuAClubsIndexRouteImport
      parentRoute: typeof MenuLazyRoute
    }
    '/_menu/a/admins/': {
      id: '/_menu/a/admins/'
      path: '/a/admins'
      fullPath: '/a/admins/'
      preLoaderRoute: typeof MenuAAdminsIndexRouteImport
      parentRoute: typeof MenuLazyRoute
    }
    '/_menu/profile/_profile/security': {
      id: '/_menu/profile/_profile/security'
      path: '/security'
      fullPath: '/profile/security'
      preLoaderRoute: typeof MenuProfileProfileSecurityRouteImport
      parentRoute: typeof MenuProfileProfileRoute
    }
    '/_menu/profile/_profile/general': {
      id: '/_menu/profile/_profile/general'
      path: '/general'
      fullPath: '/profile/general'
      preLoaderRoute: typeof MenuProfileProfileGeneralRouteImport
      parentRoute: typeof MenuProfileProfileRoute
    }
    '/_menu/ca/$clubId/_club': {
      id: '/_menu/ca/$clubId/_club'
      path: '/ca/$clubId'
      fullPath: '/ca/$clubId'
      preLoaderRoute: typeof MenuCaClubIdClubRouteImport
      parentRoute: typeof MenuLazyRoute
    }
    '/_menu/ca/$clubId/_club/': {
      id: '/_menu/ca/$clubId/_club/'
      path: '/'
      fullPath: '/ca/$clubId/'
      preLoaderRoute: typeof MenuCaClubIdClubIndexRouteImport
      parentRoute: typeof MenuCaClubIdClubRoute
    }
    '/_menu/ca/$clubId/_club/members': {
      id: '/_menu/ca/$clubId/_club/members'
      path: '/members'
      fullPath: '/ca/$clubId/members'
      preLoaderRoute: typeof MenuCaClubIdClubMembersRouteImport
      parentRoute: typeof MenuCaClubIdClubRoute
    }
    '/_menu/ca/$clubId/_club/invited': {
      id: '/_menu/ca/$clubId/_club/invited'
      path: '/invited'
      fullPath: '/ca/$clubId/invited'
      preLoaderRoute: typeof MenuCaClubIdClubInvitedRouteImport
      parentRoute: typeof MenuCaClubIdClubRoute
    }
    '/_menu/ca/$clubId/_club/dashboard': {
      id: '/_menu/ca/$clubId/_club/dashboard'
      path: '/dashboard'
      fullPath: '/ca/$clubId/dashboard'
      preLoaderRoute: typeof MenuCaClubIdClubDashboardRouteImport
      parentRoute: typeof MenuCaClubIdClubRoute
    }
    '/_menu/a/clubs/$clubId/_club': {
      id: '/_menu/a/clubs/$clubId/_club'
      path: '/a/clubs/$clubId'
      fullPath: '/a/clubs/$clubId'
      preLoaderRoute: typeof MenuAClubsClubIdClubRouteImport
      parentRoute: typeof MenuLazyRoute
    }
    '/_menu/a/clubs/$clubId/_club/members': {
      id: '/_menu/a/clubs/$clubId/_club/members'
      path: '/members'
      fullPath: '/a/clubs/$clubId/members'
      preLoaderRoute: typeof MenuAClubsClubIdClubMembersRouteImport
      parentRoute: typeof MenuAClubsClubIdClubRoute
    }
    '/_menu/a/clubs/$clubId/_club/domains': {
      id: '/_menu/a/clubs/$clubId/_club/domains'
      path: '/domains'
      fullPath: '/a/clubs/$clubId/domains'
      preLoaderRoute: typeof MenuAClubsClubIdClubDomainsRouteImport
      parentRoute: typeof MenuAClubsClubIdClubRoute
    }
    '/_menu/a/clubs/$clubId/_club/dashboard': {
      id: '/_menu/a/clubs/$clubId/_club/dashboard'
      path: '/dashboard'
      fullPath: '/a/clubs/$clubId/dashboard'
      preLoaderRoute: typeof MenuAClubsClubIdClubDashboardRouteImport
      parentRoute: typeof MenuAClubsClubIdClubRoute
    }
    '/_menu/a/clubs/$clubId/_club/admins': {
      id: '/_menu/a/clubs/$clubId/_club/admins'
      path: '/admins'
      fullPath: '/a/clubs/$clubId/admins'
      preLoaderRoute: typeof MenuAClubsClubIdClubAdminsRouteImport
      parentRoute: typeof MenuAClubsClubIdClubRoute
    }
  }
}

interface MenuProfileProfileRouteChildren {
  MenuProfileProfileGeneralRoute: typeof MenuProfileProfileGeneralRoute
  MenuProfileProfileSecurityRoute: typeof MenuProfileProfileSecurityRoute
  MenuProfileProfileIndexRoute: typeof MenuProfileProfileIndexRoute
}

const MenuProfileProfileRouteChildren: MenuProfileProfileRouteChildren = {
  MenuProfileProfileGeneralRoute: MenuProfileProfileGeneralRoute,
  MenuProfileProfileSecurityRoute: MenuProfileProfileSecurityRoute,
  MenuProfileProfileIndexRoute: MenuProfileProfileIndexRoute,
}

const MenuProfileProfileRouteWithChildren =
  MenuProfileProfileRoute._addFileChildren(MenuProfileProfileRouteChildren)

interface MenuCaClubIdClubRouteChildren {
  MenuCaClubIdClubDashboardRoute: typeof MenuCaClubIdClubDashboardRoute
  MenuCaClubIdClubInvitedRoute: typeof MenuCaClubIdClubInvitedRoute
  MenuCaClubIdClubMembersRoute: typeof MenuCaClubIdClubMembersRoute
  MenuCaClubIdClubIndexRoute: typeof MenuCaClubIdClubIndexRoute
}

const MenuCaClubIdClubRouteChildren: MenuCaClubIdClubRouteChildren = {
  MenuCaClubIdClubDashboardRoute: MenuCaClubIdClubDashboardRoute,
  MenuCaClubIdClubInvitedRoute: MenuCaClubIdClubInvitedRoute,
  MenuCaClubIdClubMembersRoute: MenuCaClubIdClubMembersRoute,
  MenuCaClubIdClubIndexRoute: MenuCaClubIdClubIndexRoute,
}

const MenuCaClubIdClubRouteWithChildren =
  MenuCaClubIdClubRoute._addFileChildren(MenuCaClubIdClubRouteChildren)

interface MenuAClubsClubIdClubRouteChildren {
  MenuAClubsClubIdClubAdminsRoute: typeof MenuAClubsClubIdClubAdminsRoute
  MenuAClubsClubIdClubDashboardRoute: typeof MenuAClubsClubIdClubDashboardRoute
  MenuAClubsClubIdClubDomainsRoute: typeof MenuAClubsClubIdClubDomainsRoute
  MenuAClubsClubIdClubMembersRoute: typeof MenuAClubsClubIdClubMembersRoute
}

const MenuAClubsClubIdClubRouteChildren: MenuAClubsClubIdClubRouteChildren = {
  MenuAClubsClubIdClubAdminsRoute: MenuAClubsClubIdClubAdminsRoute,
  MenuAClubsClubIdClubDashboardRoute: MenuAClubsClubIdClubDashboardRoute,
  MenuAClubsClubIdClubDomainsRoute: MenuAClubsClubIdClubDomainsRoute,
  MenuAClubsClubIdClubMembersRoute: MenuAClubsClubIdClubMembersRoute,
}

const MenuAClubsClubIdClubRouteWithChildren =
  MenuAClubsClubIdClubRoute._addFileChildren(MenuAClubsClubIdClubRouteChildren)

interface MenuLazyRouteChildren {
  MenuIndexRoute: typeof MenuIndexRoute
  MenuMDashboardRoute: typeof MenuMDashboardRoute
  MenuProfileProfileRoute: typeof MenuProfileProfileRouteWithChildren
  MenuCaClubIdClubRoute: typeof MenuCaClubIdClubRouteWithChildren
  MenuAAdminsIndexRoute: typeof MenuAAdminsIndexRoute
  MenuAClubsIndexRoute: typeof MenuAClubsIndexRoute
  MenuAOidcIndexRoute: typeof MenuAOidcIndexRoute
  MenuAClubsClubIdClubRoute: typeof MenuAClubsClubIdClubRouteWithChildren
}

const MenuLazyRouteChildren: MenuLazyRouteChildren = {
  MenuIndexRoute: MenuIndexRoute,
  MenuMDashboardRoute: MenuMDashboardRoute,
  MenuProfileProfileRoute: MenuProfileProfileRouteWithChildren,
  MenuCaClubIdClubRoute: MenuCaClubIdClubRouteWithChildren,
  MenuAAdminsIndexRoute: MenuAAdminsIndexRoute,
  MenuAClubsIndexRoute: MenuAClubsIndexRoute,
  MenuAOidcIndexRoute: MenuAOidcIndexRoute,
  MenuAClubsClubIdClubRoute: MenuAClubsClubIdClubRouteWithChildren,
}

const MenuLazyRouteWithChildren = MenuLazyRoute._addFileChildren(
  MenuLazyRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  MenuLazyRoute: MenuLazyRouteWithChildren,
  InvitesInviteIdRoute: InvitesInviteIdRoute,
  OidcAuthRoute: OidcAuthRoute,
  OidcErrorRoute: OidcErrorRoute,
  LinksInviteInviteIdRoute: LinksInviteInviteIdRoute,
  LinksOidcAuthRoute: LinksOidcAuthRoute,
  LinksOidcErrorRoute: LinksOidcErrorRoute,
  LinksResetUuidRoute: LinksResetUuidRoute,
  LinksResetIndexRoute: LinksResetIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
